import React from "react";
import { Link } from "react-router-dom";
import { Odometer } from "../Odometer/Odometer";
import {
  INNER_ABOUT_IMG01,
  INNER_ABOUT_IMG02,
  INNER_ABOUT_SHAPE01,
} from "../../lib/assets";

export const AboutSeven = () => {
  return (
    <section className="about-area-seven pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-9 order-0 order-lg-2">
            <div className="about-img-seven-wrap">
              <img
                src={INNER_ABOUT_IMG01}
                alt=""
                data-aos="fade-right"
                data-aos-delay="0"
              />
              <img
                src={INNER_ABOUT_IMG02}
                alt=""
                data-aos="fade-up"
                data-aos-delay="300"
              />
              <img
                src={INNER_ABOUT_SHAPE01}
                alt=""
                className="shape"
                data-aos="zoom-in"
                data-aos-delay="500"
              />
              <div
                className="experience-wrap"
                data-aos="fade-left"
                data-aos-delay="0"
              >
                <h2 className="title">25</h2>
                <p>Years Of Experience</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-content-seven">
              <div className="section-title mb-30">
                <span className="sub-title">Who We are</span>
                <h2 className="title">
                A Surrey Bookkeeper Who Explains Things in Plain English.
                </h2>
              </div>
              <p>
              Silverwave is a bookkeeping practice in Surrey, BC, 
              for startups and small businesses. We set up your books, 
              keep them current every month, and explain your numbers without the jargon.
              </p>

              <div className="success-wrap-two">
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <i className="flaticon-clock"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={15} />th
                      </h2>
                      <p>Books closed every month</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="flaticon-pin"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={4} />
                      </h2>
                      <p>Cities we serve</p>
                    </div>
                  </li>
                </ul>
              </div>

              <p className="info-two">
              Silverwave was started by [Owner full name] to help new business owners 
              with the questions that come up most: where to start, which software to use, 
              and what can and can't be paid from the business account. We answer those questions 
              and handle the monthly work, so you can focus on your customers.
              </p>

              <Link to="/contact" className="btn btn-three">
                Book a Free Health Check
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
